<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormLayout
          headline="Create Job"
          :errors="errors"
          :company-id="portalCompany.attributes.company_id"
          :content-job-regions="contentJobRegions"
          :portal="portal"
          :initial="initial"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import notify from '@/notify'
import FormLayout from '../../../../../../../../components/Administration/ContentJobs/Layouts/Form'
import LoadingContainer from '../../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {FormLayout, LoadingContainer},

  props: {
    portal: {
      required: true
    },

    portalCompanyId: {
      required: true
    }
  },

  data() {
    return {
      portalCompany: null,
      contentJobRegions: null,

      loading: true,

      errors: {},

      initial: {
        content_bodies: [],
        publish_at: moment().format('YYYY-MM-DD HH:mm:ss')
      }
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/portal-companies/' + this.portalCompanyId),
        http.get('/api/v2/content-job-regions', {'filter[portal_id]': this.portal.id})
      ]).then(responses => {
        this.portalCompany = responses[0].data.data

        this.contentJobRegions = responses[1].data.data

        this.loading = false

      })
    },

    submit(data) {
      http.post('/api/v2/content-jobs', {...data, portal_company_id: this.portalCompanyId})
          .then(() => {
            notify.success('The content job was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/jobs')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
